import RIEStatefulBase from './RIEStatefulBase';

// forked from https://github.com/kaivi/riek
export default class RIEInput extends RIEStatefulBase {

};